import { render, staticRenderFns } from "./confirmForm.vue?vue&type=template&id=39683ece&scoped=true&"
import script from "./confirmForm.vue?vue&type=script&lang=js&"
export * from "./confirmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39683ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39683ece')) {
      api.createRecord('39683ece', component.options)
    } else {
      api.reload('39683ece', component.options)
    }
    module.hot.accept("./confirmForm.vue?vue&type=template&id=39683ece&scoped=true&", function () {
      api.rerender('39683ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/fileManage/confirmForm.vue"
export default component.exports